<template>
	<ul class="catalog-list">
		<li v-for="(item, index) in showList" :key="index">
			<div class="catalog-card" :class="{ 'card-buy': isBuy }" @click="clickCard(item)">
				<p class="number">{{ index + 1 <= 9 ? '0' + (index + 1) : index + 1 }}</p>
						<!-- 公共右侧按钮 -->
						<div class="footer" v-if="isBuy">
							<img src="@/assets/images/goods/download.png" class="icon icon_material"
								v-if="type == 'material'" />
							<img src="@/assets/images/goods/pencil.png" class="icon icon_qv" v-else-if="type == 'qv'" />
							<van-icon name="arrow" v-else />
						</div>

						<!-- 身份 -->
						<template v-if="type == 'identity'">
							<div class="content">
								<p class="name">{{ item.name }}</p>
								<p class="text">
									<span>{{ item.summary }}</span>
								</p>
							</div>
						</template>

						<!-- 题集 -->
						<template v-if="type == 'qv'">

							<!-- 已购买 -->
							<template v-if="isBuy">
								<div class="content content-buy">
                  <OpenApp :unitKey="unitKey" :options="noObj" :appendParam="appendParam">
                    <p class="name">{{ item.name }}</p>
                    <p class="text">
                      <span>已练:0/{{ item.question_num }}题</span>
                      <span>巩固:0/0</span>
                    </p>
                  </OpenApp>
								</div>
							</template>

							<!-- 未购买 -->
							<template v-else>
								<div class="content" v-if="item.is_free == 0">
									<p class="name">{{ item.name }}</p>
									<p class="text">
										<span>共{{ item.question_num }}题</span>
									</p>
								</div>
                <div class="content" v-else>
                  <OpenApp class="content-free" :unitKey="unitKey" :options="noObj" :appendParam="appendParam">
                    <div class="left-area">
                      <div class="name">{{ item.name }}</div>
                      <div class="text">
                        <span>共{{ item.question_num }}题</span>
                      </div>
                    </div>
                    <div class="btn">
                      <img src="@/assets/images/goods/pen.png" alt="">
                      <div>试炼</div>
                    </div>
                  </OpenApp>
                </div>
							</template>

						</template>
						<!-- 资料 -->
						<template v-if="type == 'material'">
							<div class="content" v-if="!isBuy">
								<p class="name">{{ item.name }}</p>
								<p class="text">
									<span>共{{ item.file_size }}</span>
								</p>
							</div>

							<a :href="item.url" target="_blank" class="content" v-else>
								<p class="name">{{ item.name }}</p>
								<p class="text">
									<span>共{{ item.file_size }}</span>
								</p>
							</a>
						</template>

						<!-- 直播 -->
						<template v-if="type == 'live'">


							<!-- 已购买 -->
							<template v-if="isBuy">

								<div class="content content-buy" :class="buyLiveText(item.live_status).class">

									<!-- 未开始 -->
									<template v-if="item.live_status === 0">
										<p class="name name--gray">{{ item.name }}</p>
										<div class="text">
											<span>{{ buyLiveText(item.live_status).text }}</span>
											<span>{{ liveTimeFormat(item.start_time, item.end_time) }}</span>
										</div>
									</template>
									<!-- 直播中 -->
									<template v-if="item.live_status === 1">
										<p class="name">{{ item.name }}</p>
										<div class="text">
											<img src="@/assets/images/goods/catalog_icon_liveing.gif"
												class="icon live-icon" />
											<span style="color: #ff6a4d;">{{ buyLiveText(item.live_status).text
											}}</span>
											<span>{{ liveTimeFormat(item.start_time, item.end_time) }}</span>
										</div>
									</template>
									<!-- 已结束 -->
									<template v-if="item.live_status === 2">
										<p class="name name--gray">{{ item.name }}</p>
										<div class="text">
											<span>{{ buyLiveText(item.live_status).text }}</span>
											<span>{{ liveTimeFormat(item.start_time, item.end_time) }}</span>
										</div>
									</template>
									<!-- 可回放 -->
									<template v-if="item.live_status === 3">
										<p class="name ">{{ item.name }}</p>
										<div class="text">
											<img src="@/assets/images/goods/catalog_icon_replay.png" class="icon">
											<span>{{ buyLiveText(item.live_status).text }}</span>
										</div>
									</template>

									<!-- <p class="name">{{ item.name }}</p>
							<p class="text">
								<img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/course/skb/icon/live.png"
									class="icon" v-if="item.live_status == 1" />
								<span :class="buyLiveText(item.live_status).class">
									{{ buyLiveText(item.live_status).text }}</span>
								<span>{{ liveTimeFormat(item.start_time, item.end_time) }}</span>
							</p> -->
								</div>

								<div class="footer">
									<van-icon name="arrow" />
								</div>
							</template>

							<!-- 未购买 -->
							<template v-else>
								<div class="footer" v-if="isLiveTryPlayButton(item)">
									<a :href="item.url" class="btn">
										<img src="@/assets/images/goods/try_play.png" class="icon" />
										<span>试听</span>
									</a>
								</div>
								<div class="content">
									<p class="name">{{ item.name }}</p>
									<p class="text">
										<span>直播</span>
										<span>{{ liveTimeFormat(item.start_time, item.end_time) }}</span>
									</p>
								</div>

							</template>

						</template>

						<!-- 视频 -->
						<template v-if="type == 'vod'">
							<div class="footer" v-if="item.is_free == 1 && !isBuy">
								<a :href="item.url" class="btn">
									<img src="@/assets/images/goods/try_play.png" class="icon" />
									<span>试听</span>
								</a>
							</div>
							<div class="content">
								<p class="name">{{ item.name }}</p>
								<p class="text">
									<span>视频</span>
									<span>{{ vodTimeFormat(item.times) }}</span>
								</p>
							</div>
						</template>
			</div>
		</li>


		<div class="open-button" @click="clickMore" v-if="!isBuy && list.length >= 4 && !isMore">展开更多</div>
	</ul>
</template>

<script>
import { formatDate, formatTime } from '@/utils/date'
import OpenApp from "@/components/OpenApp.vue";
export default {
  components: {OpenApp},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: '',
		},
		isBuy: {
			type: Boolean,
			default: false,
		},
    no: {
      type: String,
      default: ''
    }
	},

	data() {
		return {
			isMore: false,
      unitKey: 'QuestionSetDetail',
      noObj: {
        no: this.no
      },
      appendParam: {}
		}
	},
	computed: {
		buyLiveText() {
			return (index) => {
				let text = {
					0: { text: '未开始', class: '' },
					1: { text: '直播中', class: 'content--live' },
					2: { text: '已结束', class: '' },
					3: { text: '可回放', class: '' },
				}
				return text[index]
			}
		},
		liveTimeFormat() {
			return (start_time, end_time) => {
				let start = formatDate(start_time),
					end = formatDate(end_time)
				return start.md + '  ' + start.hm + '-' + end.hm
			}
		},
		vodTimeFormat() {
			return (time) => {
				let vodTime = formatTime(time)
				return vodTime.hms
			}
		},
		// 是否显示直播试听按钮
		isLiveTryPlayButton() {
			return function (item) {
				return item.is_free == 1 && (item.live_status === 1 || item.live_status === 3)
			}
		},
		showList() {
			if (!this.isBuy && !this.isMore) {
				return this.list.filter((item, index) => {
					return index < 4
				})
			}

			return this.list
		}
	},
	methods: {
		clickMore() {
			this.isMore = !this.isMore
		},
		clickCard(item) {
			if (!this.isBuy) { return false }
			if (this.type === 'live') {
				this.$emit('onCatalogLive', item)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.catalog-list {
	&-more {
		@include button-background(#f7f8fa);
		@include margin_center;
		width: 5.01rem;
		height: 1.07rem;
		font-size: $font26;
	}

	&.showall {
		>li {
			display: block !important;
		}
	}

	>li {
		padding: 0.65rem 0;
		border-top: 0.01rem solid #ebecf0;

		&:nth-child(1) {
			border: none;
		}

		// &:nth-child(n + 6) {
		// 	display: none;
		// }
	}

	&_book {
		>li {
			padding: 0.72rem 0;

			.header {
				@include position_centerY;
				@include flex_center;
				width: 2.67rem;
				height: 100%;
				background: #f7f8fa;
			}

			.content {
				margin-left: 2.67rem + 0.3rem;
				height: 2.67rem;
				position: relative;

				.name {
					@include ellipsis(2);
					white-space: inherit;
					font-size: 0.43rem;
				}

				.text {
					@include ellipsis(1);
					margin-top: 0.1rem;
					font-size: 0.32rem;
				}

				.detail {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 0.5rem;
					color: #919499;
					font-size: $font24;

					.price {
						display: flex;
						align-items: flex-end;
						line-height: $font40;

						&-old {
							text-decoration: line-through;
						}

						&-news {
							color: #ff6a4d;
							font-size: $font28;
							margin-left: 0.1rem;
							font-weight: bold;

							.font {
								font-size: $font40;
							}
						}
					}
				}
			}

			.sale {
				font-size: 0.32rem;
			}
		}
	}
}

.catalog-card {
	position: relative;
	$btnWidth: 1.7rem;

	&.card-buy {
		>.number {
			position: absolute;
			top: .05rem;
			left: 0;
			line-height: .4rem;
			height: .4rem;
			transform: translateY(-0.01rem);
		}
	}

	.footer+.content {
		padding-right: $btnWidth + 0.2rem;
		box-sizing: border-box;
	}

	.content {
		margin-left: 0.9rem;
		display: block;

		&.content-buy {

			.text {
				color: #c2c5cc;
			}

		}

		.name {
			@include ellipsis(2);
			width: 100%;
			font-size: .37rem;
			margin-bottom: 0.16rem;
			color: #22242E;
			font-weight: 600;

			&--gray {
				font-weight: 500;
				color: #919499;
			}
		}

		.text {
			display: flex;
			align-items: center;
			font-size: .29rem;
			@include ellipsis;
			color: #919499;
			width: 100%;

			span {
				padding: 0 0.24rem;
				display: inline-block;


				&:nth-child(1) {
					padding-left: 0;
				}
			}

			span+span {
				position: relative;

				&::before {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0;
					width: 1px;
					height: .24rem;
					content: '';
					border-left: .001rem solid #c2c5cc;

				}
			}

			.icon {
				width: 0.32rem;
				margin-right: -.1rem;
			}

			.live-icon {
				width: .37rem;
				height: .37rem;
				margin-right: -.1rem;
			}
		}

		&--live {
			.text {}
		}
	}
  .content-free {
    width: 100%;
    position: relative;
    .left-area {
      width: calc(100% - 2.24rem);
    }
    .name {
      @include ellipsis(2);
      width: 100%;
      font-size: .37rem;
      margin-bottom: 0.16rem;
      color: #22242E;
      font-weight: 600;

      &--gray {
        font-weight: 500;
        color: #919499;
      }
    }
    .btn {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 0.29rem;
      color: #FFFFFF;
      width: 1.71rem;
      height: 0.75rem;
      background: #13BF80;
      border-radius: 0.43rem;
      img {
        width: 0.32rem;
        margin-right: 0.05rem;
      }
    }

    .text {
      display: flex;
      align-items: center;
      font-size: .29rem;
      @include ellipsis;
      color: #919499;
      width: 100%;

      span {
        padding: 0 0.24rem;
        display: inline-block;


        &:nth-child(1) {
          padding-left: 0;
        }
      }

      span+span {
        position: relative;

        &::before {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 1px;
          height: .24rem;
          content: '';
          border-left: .001rem solid #c2c5cc;

        }
      }

      .icon {
        width: 0.32rem;
        margin-right: -.1rem;
      }

      .live-icon {
        width: .37rem;
        height: .37rem;
        margin-right: -.1rem;
      }
    }

    &--live {
      .text {}
    }
  }

	.number {
		@include flex_start_center;

		width: 0.9rem;
		color: #c2c5cc;
		font-size: .37rem;

		@include position_centerY;
		height: 100%;
	}

	.footer {
		@include position_centerY;
		@include flex_center;
		right: 0;

		.van-icon-arrow {
			color: #c2c5cc;
		}

		.icon_material {
			width: 0.37rem;
		}

		.icon_qv {
			width: 0.4rem;
		}

		.btn {
			@include flex_center;

			width: $btnWidth;
			height: 0.75rem;
			border-radius: 2rem;
			background: #F7F8FA;
			font-size: $font24;
			color: #ff6a4d;
			font-weight: bold;
			font-size: 0.29rem;

			.icon {
				width: 0.32rem;
				margin-right: 0.08rem;
			}
		}
	}
}

.open-button {
	@include flex_center;
	@include margin_center;
	display: flex;
	width: 4.91rem;
	height: 1.07rem;
	background: #F7F8FA;
	border-radius: 0.53rem;
	font-size: 0.32rem;
	font-weight: 400;
	color: var(--main-color);
	margin-top: .4rem;
	margin-bottom: .6rem;
}
</style>
